const UTC_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getSmartDefault = (): { hours: string; minutes: string; date: Date } => {
  const now = new Date();
  const nextHour = (now.getUTCHours() + 1) % 24;
  let utcDay = now.getUTCDate();
  let utcMonth = now.getUTCMonth();
  let utcYear = now.getUTCFullYear();
  if (nextHour === 0) {
    // Wrapped past midnight — advance to tomorrow UTC
    const tomorrow = new Date(Date.UTC(utcYear, utcMonth, utcDay + 1));
    utcDay = tomorrow.getUTCDate();
    utcMonth = tomorrow.getUTCMonth();
    utcYear = tomorrow.getUTCFullYear();
  }
  // Build local midnight matching the intended UTC date (for react-calendar)
  return {
    hours: String(nextHour).padStart(2, '0'),
    minutes: '00',
    date: new Date(utcYear, utcMonth, utcDay),
  };
};

export const padTime = (value: string, max: number): string => {
  const num = parseInt(value, 10);
  if (isNaN(num)) return '00';
  return String(Math.min(Math.max(0, num), max)).padStart(2, '0');
};

export const buildUTCDate = (calendarDate: Date, h: string, m: string): Date => {
  // react-calendar returns local midnight — extract local Y/M/D
  const year = calendarDate.getFullYear();
  const month = calendarDate.getMonth();
  const day = calendarDate.getDate();
  // Clamp to valid ranges — prevents Date.UTC overflow (e.g., hour 99 → next day)
  const hours = Math.min(Math.max(0, parseInt(h, 10) || 0), 23);
  const minutes = Math.min(Math.max(0, parseInt(m, 10) || 0), 59);
  return new Date(Date.UTC(year, month, day, hours, minutes, 0));
};

export const formatDatetimeUTC = (date: Date): string => {
  const month = UTC_MONTHS[date.getUTCMonth()];
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();
  const h = String(date.getUTCHours()).padStart(2, '0');
  const m = String(date.getUTCMinutes()).padStart(2, '0');
  return `${month} ${day}, ${year} · ${h}:${m} UTC`;
};

export const formatLocalTime = (date: Date): string => {
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  return `${h}:${m} your local time`;
};

export const utcToCalendarDate = (utcDate: Date): Date => {
  // startDate is a UTC timestamp (e.g., 2026-03-15T00:30:00.000Z)
  // In LA (UTC-7) this is locally Mar 14 — calendar would highlight wrong day
  // Extract UTC date parts and build local midnight for correct calendar display
  return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
};
